export const Breakpoints = {
  mobile: `screen and (max-width: 42rem)`,
};
